import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, packageData } from "@/mixins/index";
import addMotherPackage from "./components/addMotherPackage";
export default {
  name: "motherPackage",
  mixins: [loadMoreList, packageData],
  components: {
    addMotherPackage: addMotherPackage
  },
  data: function data() {
    return {
      pagingReqFn: "originPkgList",
      delIds: [],
      loginData: ''
    };
  },
  activated: function activated() {
    this.getcommonData(['originPkgList']);
    this.getList();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'originPkgDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this.getList(_this.paramsData.page);
      });
    },
    pkgChange: function pkgChange(e) {
      if (e) {
        var data = this.originPkgList.find(function (i) {
          return i.id == e;
        });
        this.paramsData.id = data.id;
        this.paramsData.pkg_name = data.pkg_name;
        this.paramsData.game_group_id = data.game_group_id;
      } else {
        this.paramsData.pkg_name = '';
        this.paramsData.id = '';
        this.paramsData.game_group_id = '';
      }
    }
  }
};